module.exports = __webpack_public_path__ + "static/media/archive-icon.f53c1587.svg";